<script lang="ts" setup>
import type { ModuleVM, DescriptorVM } from '@/types/view';
import DescriptorList from '@/components/domain/DescriptorList.vue';
import { onMounted, ref } from 'vue';
import type { StatementQueueItemRef } from '@/types/view';
import MultiStatementEvaluation from './MultiStatementEvaluation.vue';
import statementService from '@/services/statement.service';
import { type StatementEvaluationResult } from '@/types/domain';
import { useToast } from 'vue-toast-notification'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const toast = useToast({ position: 'bottom', queue: true, duration: 1000 })

const props = defineProps<{
  module: ModuleVM
}>()

const descriptors = ref<DescriptorVM[]>();
const showStatementQueue = ref<boolean>(false);
const itemQueue = ref<StatementQueueItemRef[]>([]);

onMounted(() => {
  if(props.module && props.module.descriptors) {
    descriptors.value = props.module.descriptors;
  }
})

const currentRoot = ref<string | null>(null);
const setRoot = (id: string | null) => {
  currentRoot.value = id;
}

const enqueueStatementsFrom = (descriptor: DescriptorVM): StatementQueueItemRef[] => {
  return enqueueStatements(descriptor, []);
}

function enqueueStatements(descriptor: DescriptorVM, queue: StatementQueueItemRef[]) : StatementQueueItemRef[] {
  let order = 0;
  if(descriptor.descriptors) {
    descriptor.descriptors.forEach(d => {
      if(d.statements) {
        for(const s of d.statements) {
          let item :StatementQueueItemRef = { order: order++, topic: descriptor, category: d, statement: s };
          queue.push(item);
        }
      }
    })
  }

  return queue.sort((a, b) => b.order - a.order);
}


const answerAll = (descriptor: DescriptorVM | null) => {
  if(descriptor) {
    let queue = enqueueStatementsFrom(descriptor);
    itemQueue.value = queue;
    showStatementQueue.value = true;
  }
}

const persistEvaluation = (statementEvaluationResult: StatementEvaluationResult) => {
  statementService.setEvaluation(props.module.id, statementEvaluationResult.statementId, statementEvaluationResult.evaluation)
    .then(() => {
      toast.info( t('toast.evaluation-saved'), { position: 'bottom' })
    }).catch(() => {

    })
}

const close = () => {
  showStatementQueue.value = false;
}
</script>

<template>
  <template v-if="showStatementQueue">
    <MultiStatementEvaluation :statements="itemQueue" @save="persistEvaluation" @cancel="close"></MultiStatementEvaluation>
  </template>
  <div v-if="descriptors">
    <DescriptorList :descriptors="descriptors" :is-root="true" @root-selected="setRoot" @answer-all="answerAll" :current-root="currentRoot"></DescriptorList>
  </div>

</template>

<style scoped>
select {
  width: 100%;
  font-size: inherit;
  border-radius: 8px;
  padding: 8px;
  margin-bottom: 24px;
}
</style>
